/** Übersetzungen der Auswertungen; eingebunden über lib/i18n/de.ts. */
export const analyticsDe = {
  title: 'Auswertungen',
  subtitle: 'Umsatz, Deckungsbeitrag und Kundenstruktur über frei wählbare Zeiträume.',
  tabs: {
    overview: 'Überblick',
    customers: 'Kunden',
    products: 'Artikel',
    geo: 'Regionen',
    employeePerformance: 'Mitarbeiterperformance',
  },
  filters: {
    preset: 'Zeitraum',
    dateFrom: 'Von',
    dateTo: 'Bis',
    comparison: 'Vergleich',
    granularity: 'Verdichtung',
    export: 'CSV-Export',
    presets: {
      last30Days: 'Letzte 30 Tage',
      currentMonth: 'Laufender Monat',
      lastMonth: 'Vormonat',
      currentQuarter: 'Laufendes Quartal',
      currentYear: 'Laufendes Jahr',
      lastYear: 'Vorjahr',
      custom: 'Benutzerdefiniert',
    },
    comparisons: {
      NONE: 'Kein Vergleich',
      PREVIOUS_PERIOD: 'Vorperiode',
      PREVIOUS_YEAR: 'Vorjahreszeitraum',
    },
    granularities: {
      DAY: 'Tag',
      WEEK: 'Woche',
      MONTH: 'Monat',
      QUARTER: 'Quartal',
    },
  },
  validation: {
    invalidRange: 'Das Startdatum muss vor dem Enddatum liegen.',
  },
  states: {
    error: 'Die Auswertung konnte nicht geladen werden.',
    empty: 'Keine Daten im gewählten Zeitraum',
    emptyHint: 'Passen Sie den Zeitraum an oder erfassen Sie Belege, um Auswertungen zu sehen.',
  },
  export: {
    success: 'Der Export wurde erstellt.',
  },
  kpi: {
    netRevenue: 'Nettoumsatz',
    grossProfit: 'Rohertrag',
    marginPct: 'Marge',
    averageOrderValue: 'Ø Auftragswert',
    invoiceCount: 'Rechnungen',
    activeCustomers: 'Aktive Kunden',
    openReceivables: 'Offene Forderungen',
    cancelledOrderRatePct: 'Stornoquote',
    comparedToPrevious: 'im Vergleich zur Vergleichsperiode',
  },
  charts: {
    revenueTitle: 'Umsatzentwicklung',
    netRevenue: 'Nettoumsatz',
    grossProfit: 'Rohertrag',
    orderIntake: 'Auftragseingang',
    comparisonRevenue: 'Vergleichsperiode',
  },
  payment: {
    title: 'Zahlungsstatus der Rechnungen',
    paid: 'Bezahlt',
    open: 'Offen',
    overdue: 'Überfällig',
  },
  customers: {
    abcClass: 'Klasse {{abcClass}}',
    abcSummary: '{{count}} Kunden · {{share}} Umsatzanteil',
    atRisk: 'Abwanderungsgefährdet',
    industryTitle: 'Umsatz nach Branche',
    tableTitle: 'Kundenauswertung',
    columns: {
      customer: 'Kunde',
      industry: 'Branche',
      netRevenue: 'Nettoumsatz',
      grossProfit: 'Rohertrag',
      margin: 'Marge',
      orders: 'Aufträge',
      lastOrder: 'Letzter Auftrag',
      abc: 'ABC',
      churn: 'Abwanderung',
    },
    churn: {
      NONE: 'Unauffällig',
      WARNING: 'Beobachten',
      CRITICAL: 'Kritisch',
    },
  },
  products: {
    groupTitle: 'Deckungsbeitrag I nach Warengruppe',
    tableTitle: 'Artikelauswertung',
    slowMoverTitle: 'Ladenhüter',
    totals: {
      netRevenue: 'Nettoumsatz',
      costOfGoods: 'Wareneinsatz',
      contributionMargin1: 'Deckungsbeitrag I',
      productCount: 'Artikel',
    },
    columns: {
      product: 'Artikel',
      group: 'Warengruppe',
      quantity: 'Menge',
      netRevenue: 'Nettoumsatz',
      contributionMargin1: 'DB I',
      contributionMargin2: 'DB II',
      margin: 'Marge',
      returnRate: 'Retourenquote',
      stockQuantity: 'Bestand',
      stockValue: 'Bestandswert',
      lastMovement: 'Letzte Bewegung',
      daysSinceMovement: 'Tage ohne Bewegung',
    },
  },
  geo: {
    regionTitle: 'Umsatz nach Region',
    regionTableTitle: 'Regionen',
    countryTitle: 'Umsatz nach Land',
    regions: {
      DOMESTIC: 'Inland',
      EU: 'EU',
      THIRD_COUNTRY: 'Drittland',
    },
    columns: {
      region: 'Region',
      country: 'Land',
      netRevenue: 'Nettoumsatz',
      documents: 'Belege',
      customers: 'Kunden',
      share: 'Anteil',
    },
  },
  employeePerformance: {
    teamTitle: 'Teamübersicht Mitarbeiterperformance',
    teamSubtitle: 'Objektive ERP-, Beleg- und Telefoniekennzahlen im gewählten Zeitraum.',
    updatedAt: 'Datenstand {{date}} · Zeitzone {{timezone}}',
    emptyHint:
      'Passen Sie die Mitarbeiter- oder Fachfilter an. Mitarbeiter ohne Aktivität bleiben in der Auswahl sichtbar.',
    minutes: '{{value}} Min.',
    noComparison: 'Kein belastbarer Vergleichswert',
    comparisonValue: 'Vergleichswert: {{value}}',
    showDefinition: 'Definition für {{metric}} anzeigen',
    chartAriaLabel: 'Zeitverlauf von Umsatz und Auftragseingang',
    telephonyChartAriaLabel: 'Zeitverlauf von CTI-Telefonaten und Gesprächsdauer',
    chartDescription:
      'Diagramm mit {{count}} Zeitabschnitten. Die Werte stehen zusätzlich in den Kennzahlen und Tabellen.',
    privacy: {
      title: 'Verantwortungsvoller Umgang mit Beschäftigtendaten',
      description:
        'Diese Auswertung ist zweckgebunden für betriebliche Leistungsanalyse. Kennzahlen benötigen fachlichen Kontext und dürfen nicht alleinige Grundlage automatisierter Personalentscheidungen sein. Kommunikationsinhalte, Audio, Transkripte, KI-Zusammenfassungen, Stimmung und Persönlichkeitsmerkmale werden weder angezeigt noch bewertet.',
    },
    activation: {
      title: 'Mitarbeiterperformance ist deaktiviert',
      description:
        'Die Funktion ist mandantenbezogen ausgeschaltet. Eine Aktivierung speichert keine neuen Performance-Rohdaten, sondern wertet vorhandene, mandantenbezogene ERP-Daten aggregiert aus.',
      legalReview:
        'Vor der produktiven Aktivierung sind Informationspflichten, betriebliche Regelungen, Rechtsgrundlage und gegebenenfalls Beteiligungsrechte zu prüfen.',
      enable: 'Nach Prüfung aktivieren',
      disable: 'Auswertung deaktivieren',
      enabledSuccess: 'Die Mitarbeiterperformance wurde für diesen Mandanten aktiviert.',
      disabledSuccess: 'Die Mitarbeiterperformance wurde für diesen Mandanten deaktiviert.',
    },
    status: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
      unassigned: 'Nicht zugeordnet',
    },
    filters: {
      employees: 'Mitarbeiter',
      allEmployees: 'Alle Mitarbeiter',
      selectedCount: '{{count}} ausgewählt',
      clearSelection: 'Auswahl zurücksetzen',
      employeeStatus: 'Mitarbeiterstatus',
      employeeStatuses: {
        ACTIVE: 'Nur aktive',
        INACTIVE: 'Nur inaktive',
        ALL: 'Aktive und inaktive',
      },
      documentTypes: 'Belegarten',
      allDocumentTypes: 'Alle Verkaufsbelege',
      documentStatuses: 'Belegstatus',
      allDocumentStatuses: 'Alle relevanten Status',
      phoneDirections: 'Telefonierichtung',
      allPhoneDirections: 'Ein- und ausgehend',
      phoneDirection: {
        INBOUND: 'Eingehend',
        OUTBOUND: 'Ausgehend',
      },
      customerGroups: 'Kundengruppen',
      countryCodes: 'Länder',
      salesRegions: 'Vertriebsgebiete',
      commaSeparated: 'Kommagetrennt',
      conversionWindow: 'Kontaktfenster (Tage)',
      includeUnassigned: 'Nicht zugeordnete Daten einbeziehen',
    },
    kpis: {
      netRevenue: {
        label: 'Teamumsatz netto',
        definition:
          'Summe relevanter Rechnungsnettos abzüglich festgeschriebener Stornos und Gutschriften; Datum: Belegdatum, Zuordnung: revisionsfähiger Vertriebsmitarbeiter-Snapshot.',
      },
      orderIntake: {
        label: 'Auftragseingang',
        definition:
          'Nettowert bestätigter, laufender, teilweise bearbeiteter oder abgeschlossener Aufträge nach Belegdatum und Vertriebszuordnung.',
      },
      grossProfit: {
        label: 'Rohertrag',
        definition:
          'Fakturierter Nettoumsatz einschließlich negativer Korrekturen abzüglich eingefrorenem Wareneinsatz der Belegpositionen.',
      },
      totalCalls: {
        label: 'Telefonate',
        definition:
          'Anzahl eindeutiger CTI-/Ringover-Einträge aus CommunicationLog nach Startzeit und CommunicationLog.userId. Manuelle CallLog-Einträge sind nicht enthalten.',
      },
      quoteToOrderConversionPct: {
        label: 'Angebotskonversion',
        definition:
          'Gewichteter Teamanteil relevanter Angebote mit einem qualifizierten Folgeauftrag über sourceDocumentId; keine Ähnlichkeitsschätzung.',
      },
    },
    chart: {
      title: 'Umsatz, Auftragseingang und Telefonie im Zeitverlauf',
      netRevenue: 'Nettoumsatz',
      orderIntake: 'Auftragseingang',
      comparisonRevenue: 'Nettoumsatz Vergleich',
      calls: 'CTI-Telefonate',
      callDuration: 'CTI-Gesprächsdauer',
    },
    unassigned: {
      title: 'Nicht zugeordnete Belege',
      description:
        'Diese Werte besitzen keine belastbare Vertriebszuordnung und werden bewusst keiner Person zugerechnet. CTI-Telefonate sind technisch immer einem Benutzer zugeordnet.',
    },
    table: {
      title: 'Mitarbeiter ({{count}})',
      employee: 'Mitarbeiter',
      status: 'Status',
      netRevenue: 'Fakturierter Nettoumsatz',
      orderIntake: 'Auftragseingang',
      grossProfit: 'Rohertrag',
      margin: 'Marge',
      quotes: 'Angebote',
      orders: 'Aufträge',
      invoices: 'Rechnungen',
      quoteConversion: 'Angebotskonversion',
      averageOrderValue: 'Ø Auftragswert',
      calls: 'Telefonate',
      callDuration: 'Gesprächsdauer',
      reachability: 'Erreichbarkeit',
      customers: 'Betreute Kunden',
      comparison: 'Vergleich Vorperiode',
      documents: 'Belege',
      documentSummary: '{{quotes}} Angebote · {{orders}} Aufträge · {{invoices}} Rechnungen',
      columns: 'Spalten',
      visibleColumns: 'Sichtbare Spalten',
      openEmployee: 'Detailansicht für {{name}} öffnen',
      page: 'Seite {{page}} von {{pages}} · {{count}} Einträge',
      columnLabels: {
        isActive: 'Status',
        netRevenue: 'Fakturierter Nettoumsatz',
        orderIntake: 'Auftragseingang',
        grossProfit: 'Rohertrag',
        marginPct: 'Marge',
        quoteCount: 'Angebote',
        orderCount: 'Aufträge',
        invoiceCount: 'Rechnungen',
        quoteToOrderConversionPct: 'Angebotskonversion',
        averageOrderValue: 'Ø Auftragswert',
        totalCalls: 'Telefonate',
        totalCallDurationSeconds: 'Gesprächsdauer',
        reachabilityPct: 'Erreichbarkeit',
        servedCustomerCount: 'Betreute Kunden',
        comparisonDeltaPct: 'Vergleich Vorperiode',
      },
    },
    funnel: {
      QUOTE: 'Angebote',
      ORDER: 'Aufträge',
      DELIVERY_NOTE: 'Lieferscheine',
      INVOICE: 'Rechnungen',
    },
    detail: {
      title: 'Mitarbeiterdetails',
      description:
        'Aggregierte Geschäftskennzahlen ohne Kommunikationsinhalte oder Persönlichkeitsbewertung.',
      updatedAt: 'Datenstand {{date}}',
      development: 'Eigener Verlauf und Vergleichszeitraum',
      funnel: 'Belegtrichter Angebot → Auftrag → Lieferschein → Rechnung',
      salesMetrics: 'Vertrieb, Umsatz und Belegqualität',
      telephony: 'Telefonieaggregat',
      telephonyPrivacy:
        'Manuell protokollierte Kundenanrufe werden separat ausgewiesen. Audio, Rufnummern, Transkripte, Inhalte, Zusammenfassungen und Stimmungen werden hier nicht verarbeitet.',
      quality: 'Qualität und Korrekturen',
      customerActivities: 'Dokumentierte Kundenaktivitäten nach Kanal',
      customerStructure: 'Kundenstruktur',
      definitions: 'Kennzahlendefinitionen und Datenbasis',
      inboundCalls: 'Eingehend',
      outboundCalls: 'Ausgehend',
      answeredCalls: 'Angenommen',
      missedCalls: 'Verpasst (eingehend)',
      notReachedCalls: 'Nicht erreicht (ausgehend)',
      failedCalls: 'Technisch fehlgeschlagen',
      callDuration: 'Gesamtdauer',
      averageCallDuration: 'Ø angenommene Gesprächsdauer',
      unknownNumbers: 'Nicht zuordenbare Nummern',
      manualCalls: 'Manuelle Kundenanrufe',
      corrections: 'Storno-/Gutschriftenwert',
      cancellationRate: 'Korrekturquote',
      fullyPaidRate: 'Vollständig bezahlt',
      averageDiscount: 'Ø Rabattquote',
      openFollowUps: 'Offene Follow-ups',
      overdueFollowUps: 'Überfällige Follow-ups',
      partnerAssigned: 'Mit Geschäftspartner',
      technicallyProcessed: 'Technisch abgeschlossen',
      newCustomerRevenue: 'Neukundenumsatz',
      existingCustomerRevenue: 'Bestandskundenumsatz',
      newCustomers: 'Neue Kunden',
      reactivatedCustomers: 'Reaktivierte Kunden',
      customer: 'Kunde',
      noCustomers: 'Keine belastbar zugeordneten Kunden im Zeitraum.',
      summary: {
        netRevenue: 'Nettoumsatz',
        orderIntake: 'Auftragseingang',
        grossProfit: 'Rohertrag',
        marginPct: 'Marge',
        totalCalls: 'CTI-Telefonate',
        reachabilityPct: 'Erreichbarkeit',
        servedCustomerCount: 'Betreute Kunden',
        netRevenueComparison: 'Umsatzveränderung',
      },
    },
    definitionLabels: {
      netRevenue: 'Fakturierter Nettoumsatz',
      grossRevenue: 'Fakturierter Bruttoumsatz',
      paidNetRevenue: 'Bezahlter Nettoumsatz',
      openInvoiceAmount: 'Offener Rechnungsbetrag',
      overdueInvoiceAmount: 'Überfälliger Rechnungsbetrag',
      correctionValue: 'Storno- und Gutschriftenwert',
      correctionCount: 'Storno- und Korrekturbelege',
      costOfGoods: 'Wareneinsatz',
      grossProfit: 'Rohertrag',
      marginPct: 'Rohertragsmarge',
      averageInvoiceValue: 'Durchschnittlicher Rechnungswert',
      revenueSharePct: 'Umsatzanteil am Team',
      orderIntake: 'Auftragseingang',
      quoteCount: 'Angebote',
      quoteValue: 'Angebotswert netto',
      orderCount: 'Aufträge',
      orderValue: 'Auftragswert netto',
      deliveryCount: 'Lieferscheine',
      deliveryValue: 'Lieferscheinwert netto',
      invoiceCount: 'Gebuchte Rechnungen',
      averageOrderValue: 'Durchschnittlicher Auftragswert',
      quoteToOrderConversionPct: 'Angebot-zu-Auftrag-Konversion',
      orderToInvoiceConversionPct: 'Auftrag-zu-Rechnung-Konversion',
      averageQuoteToOrderDays: 'Dauer Angebot zu Auftrag',
      averageOrderToInvoiceDays: 'Dauer Auftrag zu Rechnung',
      wonQuoteCount: 'Gewonnene Angebote',
      lostQuoteCount: 'Verlorene Angebote',
      averageDiscountPct: 'Durchschnittliche Rabattquote',
      cancellationRatePct: 'Korrekturquote',
      fullyPaidInvoiceRatePct: 'Anteil vollständig bezahlter Rechnungen',
      totalCalls: 'CTI-Telefonate',
      inboundCalls: 'Eingehende Telefonate',
      outboundCalls: 'Ausgehende Telefonate',
      answeredCalls: 'Angenommene Telefonate',
      missedCalls: 'Verpasste eingehende Telefonate',
      notReachedCalls: 'Nicht erreichte ausgehende Telefonate',
      failedCalls: 'Fehlgeschlagene Telefonate',
      voicemailCalls: 'Voicemail-Telefonate',
      reachabilityPct: 'Erreichbarkeitsquote',
      totalCallDurationSeconds: 'Gesamte Gesprächsdauer',
      averageCallDurationSeconds: 'Durchschnittliche Gesprächsdauer',
      longestCallSeconds: 'Längstes Gespräch',
      uniquePartnerContacts: 'Eindeutige Geschäftspartnerkontakte',
      unknownPhoneNumbers: 'Nicht zuordenbare Telefonnummern',
      callsPerWorkday: 'Telefonate je Arbeitstag',
      manualCallCount: 'Manuelle Kundenanrufe',
      partnerAssignedCallPct: 'Telefonate mit Geschäftspartner',
      technicallyProcessedCallPct: 'Technisch verarbeitete Telefonate',
      servedCustomerCount: 'Betreute aktive Kunden',
      newCustomerCount: 'Neue Kunden',
      reactivatedCustomerCount: 'Reaktivierte Kunden',
      newCustomerRevenue: 'Neukundenumsatz',
      existingCustomerRevenue: 'Bestandskundenumsatz',
      revenuePerCustomer: 'Umsatz je betreutem Kunden',
      sentEmailCount: 'Versendete Belege und E-Mails',
      sentWhatsAppCount: 'Gesendete WhatsApp-Nachrichten',
      noteCount: 'Dokumentierte Kundennotizen',
      openFollowUpCount: 'Offene Follow-ups',
      overdueFollowUpCount: 'Überfällige Follow-ups',
      callToQuoteConversionPct: 'Telefonat-zu-Angebot-Konversion',
      callToOrderConversionPct: 'Telefonat-zu-Auftrag-Konversion',
      netRevenueComparison: 'Umsatzveränderung zum Vergleichszeitraum',
    },
    definitions: {
      netRevenue:
        'Rechnungen in POSTED, COMPLETED oder CANCELLED abzüglich festgeschriebener Stornos und Gutschriften. Entwürfe, gelöschte Belege und isoliert stornierte Entwürfe zählen nicht. Maßgeblich sind Document.documentDate und der revisionsfähige Vertriebszuordnungs-Snapshot.',
      grossRevenue:
        'Wie der fakturierte Nettoumsatz, jedoch mit Document.grossTotal einschließlich Steuern; festgeschriebene Stornos und Gutschriften werden als negative Bruttokorrektur verrechnet.',
      paidNetRevenue:
        'Nettoumsatzanteil proportional zum gespeicherten paidAmount am Bruttobetrag. Die Datenbasis enthält kein belastbares Zahlungsdatum; deshalb wird keine durchschnittliche Zahlungsdauer ausgewiesen.',
      openInvoiceAmount:
        'Positive Bruttorestbeträge relevanter Rechnungen mit OPEN, PARTIALLY_PAID oder OVERDUE zum aktuellen Datenstand.',
      overdueInvoiceAmount:
        'Offene Bruttorestbeträge, deren dueDate vor dem heutigen Kalendertag in der Mandantenzeitzone liegt.',
      correctionValue:
        'Nettowert festgeschriebener CANCELLATION- und CREDIT_NOTE-Belege als negative Korrektur. Die Ursprungsrechnung bleibt für die nachvollziehbare Gegenbuchung erhalten.',
      correctionCount:
        'Anzahl festgeschriebener CANCELLATION- und CREDIT_NOTE-Belege nach Document.documentDate und revisionsfähiger Vertriebszuordnung.',
      costOfGoods:
        'Summe aus DocumentItem.costPrice × quantityBase der umsatzrelevanten Rechnungspositionen; Kosten aus Storno- und Gutschriftenpositionen werden negativ zurückgeführt.',
      grossProfit:
        'Fakturierter Nettoumsatz einschließlich Korrekturen minus Summe aus costPrice × quantityBase der zugehörigen Belegpositionen.',
      marginPct:
        'Rohertrag geteilt durch fakturierten Nettoumsatz × 100; bei Umsatz null nicht definiert.',
      averageInvoiceValue:
        'Summe der Nettowerte relevanter Rechnungen vor Korrekturbelegen geteilt durch die Anzahl dieser Rechnungen.',
      revenueSharePct:
        'Fakturierter Nettoumsatz des Mitarbeiters geteilt durch den Nettoumsatz des aktuell gefilterten Teams einschließlich eingeblendeter nicht zugeordneter Werte × 100.',
      orderIntake:
        'Nettowert von Aufträgen in CONFIRMED, IN_PROGRESS, PARTIALLY_PROCESSED oder COMPLETED nach Document.documentDate.',
      quoteCount:
        'Anzahl der Angebote in SENT, ACCEPTED oder REJECTED nach Document.documentDate und revisionsfähigem Vertriebszuordnungs-Snapshot.',
      quoteValue:
        'Summe der Nettowerte dieser qualifizierten Angebote nach Document.documentDate und Vertriebszuordnung.',
      orderCount:
        'Anzahl der Aufträge in CONFIRMED, IN_PROGRESS, PARTIALLY_PROCESSED oder COMPLETED nach Document.documentDate.',
      orderValue:
        'Summe der Nettowerte qualifizierter Aufträge; entspricht dem ausgewiesenen Auftragseingang.',
      deliveryCount:
        'Anzahl der Lieferscheine in SHIPPED oder COMPLETED nach Document.documentDate und Vertriebszuordnung.',
      deliveryValue:
        'Summe der Nettowerte von Lieferscheinen in SHIPPED oder COMPLETED nach Document.documentDate und Vertriebszuordnung.',
      invoiceCount:
        'Anzahl der Rechnungen in POSTED oder COMPLETED nach Document.documentDate; Korrekturbelege werden separat gezählt.',
      averageOrderValue:
        'Nettowert qualifizierter Aufträge geteilt durch deren Anzahl; bei keinem Auftrag wird 0 ausgewiesen.',
      quoteToOrderConversionPct:
        'Anteil relevanter Angebote mit mindestens einem qualifizierten Auftrag, dessen sourceDocumentId exakt auf das Angebot zeigt.',
      orderToInvoiceConversionPct:
        'Anteil relevanter Aufträge mit einer qualifizierten Rechnung direkt oder über einen Lieferschein im tatsächlichen sourceDocumentId-Belegfluss.',
      averageQuoteToOrderDays:
        'Durchschnittliche Kalendertage vom Belegdatum des Angebots bis zum frühesten qualifizierten Folgeauftrag im Belegfluss.',
      averageOrderToInvoiceDays:
        'Durchschnittliche Kalendertage vom Belegdatum des Auftrags bis zur frühesten qualifizierten Rechnung direkt oder über Lieferschein.',
      wonQuoteCount:
        'Anzahl relevanter Angebote mit Status ACCEPTED nach Document.documentDate und Vertriebszuordnung.',
      lostQuoteCount:
        'Anzahl relevanter Angebote mit Status REJECTED nach Document.documentDate und Vertriebszuordnung.',
      averageDiscountPct:
        'Gewährte Kopf- und Positionsrabatte bestätigter Aufträge geteilt durch deren Nettowert vor Rabatt × 100.',
      cancellationRatePct:
        'Anzahl festgeschriebener Storno-/Gutschriftenbelege geteilt durch Rechnungen plus Korrekturbelege × 100.',
      fullyPaidInvoiceRatePct:
        'Anzahl relevanter Rechnungen mit PaymentStatus PAID geteilt durch alle relevanten Rechnungen × 100.',
      totalCalls:
        'Anzahl eindeutiger CommunicationLog-Datensätze nach startedAt in der Mandantenzeitzone und CommunicationLog.userId. CallLog wird nicht eingemischt.',
      inboundCalls:
        'Anzahl der CTI-Einträge mit CommunicationLog.direction = INBOUND nach startedAt und userId.',
      outboundCalls:
        'Anzahl der CTI-Einträge mit CommunicationLog.direction = OUTBOUND nach startedAt und userId.',
      answeredCalls: 'Anzahl der CTI-Einträge mit CommunicationLog.status = ANSWERED.',
      missedCalls: 'Anzahl eingehender CTI-Einträge mit Status MISSED.',
      notReachedCalls:
        'Anzahl ausgehender CTI-Einträge mit Status MISSED; sie werden getrennt von verpassten eingehenden Gesprächen ausgewiesen.',
      failedCalls: 'Anzahl der CTI-Einträge mit CommunicationLog.status = FAILED.',
      voicemailCalls: 'Anzahl der CTI-Einträge mit CommunicationLog.status = VOICEMAIL.',
      reachabilityPct:
        'Angenommene CTI-Telefonate geteilt durch abgeschlossene Ergebnisgruppen angenommen, verpasst, nicht erreicht, Voicemail und fehlgeschlagen × 100.',
      totalCallDurationSeconds:
        'Summe von CommunicationLog.durationSeconds aller CTI-Telefonate im Zeitraum; manuelle CallLog-Einträge sind ausgeschlossen.',
      averageCallDurationSeconds:
        'Durchschnitt von CommunicationLog.durationSeconds ausschließlich für angenommene CTI-Telefonate.',
      longestCallSeconds:
        'Größter gespeicherter Wert von CommunicationLog.durationSeconds im gewählten Zeitraum.',
      uniquePartnerContacts:
        'Anzahl eindeutiger, über CommunicationLog.partnerId zugeordneter Geschäftspartnerkontakte.',
      unknownPhoneNumbers:
        'Anzahl eindeutiger externer Rufnummern aus CTI-Telefonaten ohne aufgelösten CommunicationLog.partnerId; Rufnummern selbst werden nicht ausgegeben.',
      callsPerWorkday:
        'CTI-Telefonate geteilt durch Montage bis Freitage des gewählten Mandanten-Kalenderzeitraums; Feiertage werden nicht unterstellt.',
      manualCallCount:
        'Separat gezählte, manuell dokumentierte Kundenanrufe aus CallLog nach occurredAt und userId; keine Zusammenführung mit CTI-Einträgen.',
      partnerAssignedCallPct:
        'CTI-Telefonate mit aufgelöstem CommunicationLog.partnerId geteilt durch alle CTI-Telefonate × 100.',
      technicallyProcessedCallPct:
        'CTI-Einträge mit endedAt und einem Status ungleich RINGING geteilt durch alle CTI-Einträge × 100.',
      servedCustomerCount:
        'Eindeutige aktive Geschäftspartner mit qualifiziertem Beleg oder zugeordnetem CTI-Kontakt des Mitarbeiters im Zeitraum.',
      newCustomerCount:
        'Eindeutige Kunden, deren erste qualifizierte Rechnung im gewählten Zeitraum liegt und dem Mitarbeiter zugeordnet ist.',
      reactivatedCustomerCount:
        'Eindeutige Kunden mit neuer qualifizierter Rechnung nach mindestens 180 Kalendertagen ohne qualifizierte Rechnung.',
      newCustomerRevenue:
        'Fakturierter Nettoumsatz einschließlich Korrekturen von Kunden, deren erste qualifizierte Rechnung im gewählten Zeitraum liegt.',
      existingCustomerRevenue:
        'Fakturierter Nettoumsatz einschließlich Korrekturen von Kunden, deren erste qualifizierte Rechnung vor dem gewählten Zeitraum liegt.',
      revenuePerCustomer:
        'Fakturierter Nettoumsatz geteilt durch die Anzahl betreuter aktiver Kunden; bei null Kunden 0.',
      sentEmailCount:
        'Anzahl erfolgreicher EmailLog-Einträge mit Status SENT nach sentAt und sentByUserId; Beleg- und Kundenfilter werden berücksichtigt.',
      sentWhatsAppCount:
        'Anzahl ausgehender WhatsAppMessage-Einträge in SENT, DELIVERED oder READ nach sentAt beziehungsweise createdAt und senderUserId.',
      noteCount:
        'Anzahl der CustomerNote-Einträge nach occurredAt und authorId im gewählten Zeitraum.',
      openFollowUpCount:
        'Kundennotizen des Zeitraums mit followUpAt und ohne followUpDoneAt zum aktuellen Datenstand.',
      overdueFollowUpCount:
        'Offene Follow-ups aus Kundennotizen des Zeitraums, deren followUpAt bereits überschritten ist.',
      callToQuoteConversionPct:
        'Anteil der CTI-Telefonate, nach denen für denselben Geschäftspartner und Mitarbeiter innerhalb des konfigurierten Fensters ein qualifiziertes Angebot entstand. Das zeigt zeitliche Zuordnung, keine gesicherte Kausalität.',
      callToOrderConversionPct:
        'Anteil der CTI-Telefonate, nach denen für denselben Geschäftspartner und Mitarbeiter innerhalb des konfigurierten Fensters ein qualifizierter Auftrag entstand. Das zeigt zeitliche Zuordnung, keine gesicherte Kausalität.',
      netRevenueComparison:
        'Prozentuale Veränderung des fakturierten Nettoumsatzes gegenüber Vorperiode oder Vorjahreszeitraum. Bei Vergleichswert null ist keine Prozentänderung definiert.',
    },
  },
};
